import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Stack, Typography, Button, TextField, useMediaQuery } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Navbar from './Navbar';
import RightSide from './RightSide';
import logo from '../assets/logo.png';
import { api_Routes } from "../api_Route";
import { Helper } from "../Tools/Helper";
import { useSnackbar } from "notistack";

function RealLogin() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:768px)');

    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        if (!email || !password) {
            setError("جميع الحقول مطلوبة");
            return;
        }

        setIsLoading(true);
        try {
            const { response, message } = await Helper.Post({
                url: api_Routes.auth.login,
                data: { email, password },
                hasToken: false,
            });

            if (response) {
                enqueueSnackbar(message, { variant: "success" });
                localStorage.setItem("user", JSON.stringify({
                    user_id: response.data?.id,
                    token: response.data?.token,
                    username: response.data?.username,
                }));
                navigate("/dashboard"); // Redirect to dashboard or any other route after login
            } else {
                enqueueSnackbar(message || "حدث خطأ أثناء العملية.", { variant: "error" });
            }
        } catch {
            enqueueSnackbar("حدث خطأ أثناء إرسال النموذج.", { variant: "error" });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Navbar />
            <Stack
                direction={isMobile ? "column" : "row"}
                sx={{ borderLeft: "30px solid #15513c", minHeight: "100vh" }}
            >
                {/* Left Side - Login Form */}
                <Stack
                    alignItems="center"
                    sx={{
                        flexBasis: isMobile ? "100%" : "50%",
                        justifyContent: "center",
                        px: isMobile ? 2 : 0,
                        py: isMobile ? 4 : 0
                    }}
                >
                    <Stack sx={{ width: "90%", maxWidth: "400px" }} spacing={3}>
                        <Box sx={{ textAlign: "center" }}>
                            <img src={logo} alt="Logo" width="60px" />
                        </Box>

                        <Box textAlign="center">
                            <Typography variant="h6" fontWeight="bold">
                                مرحبًا بك مجددًا في منصة نبني
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                قم بتسجيل الدخول للوصول إلى ملفك الشخصي، تحديث احتياجاتك، وتتبع حالة طلبات الدعم
                            </Typography>
                        </Box>

                        <Box component="form" sx={{ display: "flex", flexDirection: "column", gap: 2 }} onSubmit={handleLoginSubmit}>
                            <TextField
                                label="البريد الإلكتروني"
                                variant="outlined"
                                fullWidth
                                placeholder="قم بإدخال بريدك الإلكتروني"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                name="email"
                            />
                            <TextField
                                label="كلمة المرور"
                                variant="outlined"
                                fullWidth
                                placeholder="قم بإدخال كلمة المرور"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                name="password"
                            />

                            {error && (
                                <Typography variant="body2" color="error" textAlign="center">
                                    {error}
                                </Typography>
                            )}

                            <Button
                                variant="contained"
                                fullWidth
                                sx={{ backgroundColor: "#15513c", color: "#fff", borderRadius: "6px", py: 1.5 }}
                                type="submit"
                                disabled={isLoading}
                            >
                                <ArrowBackIcon sx={{ ml: 1 }} />
                                تسجيل الدخول
                            </Button>
                        </Box>
                    </Stack>
                </Stack>

                {/* Right Side (Hidden on Mobile) */}
                {!isMobile && <RightSide />}
            </Stack>
        </>
    );
}

export default RealLogin;